export default __webpack_public_path__ + "static/media/Configuracoes.fad05e52.svg";